module.exports = __webpack_public_path__ + "daa3c7a61b284250159981abd0139a21.svg";